import { MultiselectCategoryListCSSStyleImpl } from '../../login/createaccountcomponent/categorylist/multiselectcategorylistcss';
import { Fonts } from '../../../../utils/resources/fonts';
import { Colors } from '../../../../utils/resources/colors';
export class PreferenceCategoryListCSSStyleImpl extends MultiselectCategoryListCSSStyleImpl
{
    getTitleCSSStyle(): object 
    {
        return {
            display: "flex",
            textAlign: "center",
            justifyContent: 'flex-start',
            height: "40px",
            fontWeight: 500,
            letterSpacing: 0,
            textShadow: "0 1px 1px 0 rgba(0,0,0,0.18)",
            fontSize: this.getResources().getFont(Fonts.h7),
            color: this.getResources().getColor(Colors.color_7),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "40px",
            marginBottom: '10px',
            marginTop: '10px', 
            marginLeft: '0px',
        };
    } 
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/myaccount/preferences/preferncecategorylistcss.tsx